import Component from "./ModalSubmitted";

export default Component;
